import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/articles")({
  staticData: { title: "Articles" },
  component: () => <Outlet />,
});
